// Simple city highlights catalog for the landing page.
// In a real system this would come from your backend.

const normalizeCity = (name) => (name || '').trim().toLowerCase();

export const CITY_HIGHLIGHTS = {
  mumbai: {
    city: 'Mumbai',
    dishes: [
      { id: 'vada-pav', name: 'Vada Pav', tags: ['Street food'], description: 'Spicy potato fritter in a bun.' },
      { id: 'pav-bhaji', name: 'Pav Bhaji', tags: ['Street food'], description: 'Buttery pav with mashed spicy veggies.' },
      { id: 'bhel', name: 'Bhel Puri', tags: ['Chaat'], description: 'Puffed rice, chutneys, crunchy sev.' },
      { id: 'misal', name: 'Misal Pav', tags: ['Spicy'], description: 'Sprouts curry topped with farsan.' }
    ],
    restaurants: [
      { id: 'a-1', name: 'Cafe Madras', area: 'Matunga', popularDishes: ['misal', 'vada-pav'] },
      { id: 'a-2', name: 'Sardar Pav Bhaji', area: 'Tardeo', popularDishes: ['pav-bhaji'] },
      { id: 'a-3', name: 'Elco Pani Puri', area: 'Bandra', popularDishes: ['bhel'] }
    ]
  },
  delhi: {
    city: 'Delhi',
    dishes: [
      { id: 'chole-bhature', name: 'Chole Bhature', tags: ['North Indian'], description: 'Chickpea curry with fluffy bhature.' },
      { id: 'butter-chicken', name: 'Butter Chicken', tags: ['Classic'], description: 'Creamy tomato gravy with chicken.' },
      { id: 'chaat', name: 'Delhi Chaat', tags: ['Chaat'], description: 'Gol gappe, papdi chaat, aloo tikki.' },
      { id: 'paratha', name: 'Stuffed Paratha', tags: ['Breakfast'], description: 'Parathas with butter and pickles.' }
    ],
    restaurants: [
      { id: 'd-1', name: 'Karim’s', area: 'Jama Masjid', popularDishes: ['butter-chicken'] },
      { id: 'd-2', name: 'Sita Ram Diwan Chand', area: 'Paharganj', popularDishes: ['paratha'] },
      { id: 'd-3', name: 'Chache Di Hatti', area: 'Kamla Nagar', popularDishes: ['chole-bhature'] }
    ]
  },
  bengaluru: {
    city: 'Bengaluru',
    dishes: [
      { id: 'dosa', name: 'Masala Dosa', tags: ['South Indian'], description: 'Crispy dosa with potato masala.' },
      { id: 'idli', name: 'Idli Vada', tags: ['South Indian'], description: 'Soft idlis with vada and chutney.' },
      { id: 'bisi-bele', name: 'Bisi Bele Bath', tags: ['Comfort'], description: 'Spiced rice-lentil dish.' },
      { id: 'filter-coffee', name: 'Filter Coffee', tags: ['Cafe'], description: 'Strong, frothy South Indian coffee.' }
    ],
    restaurants: [
      { id: 'b-1', name: 'Vidyarthi Bhavan', area: 'Basavanagudi', popularDishes: ['dosa'] },
      { id: 'b-2', name: 'MTR', area: 'Lalbagh', popularDishes: ['idli', 'filter-coffee'] },
      { id: 'b-3', name: 'Nagarjuna', area: 'Residency Road', popularDishes: ['bisi-bele'] }
    ]
  }
};

export const getHighlightsForCity = (cityName) => {
  const key = normalizeCity(cityName);
  if (!key) return null;

  // Try direct match
  if (CITY_HIGHLIGHTS[key]) return CITY_HIGHLIGHTS[key];

  // Try common aliases
  const aliases = {
    bangalore: 'bengaluru'
  };
  const alias = aliases[key];
  if (alias && CITY_HIGHLIGHTS[alias]) return CITY_HIGHLIGHTS[alias];

  return {
    city: cityName,
    dishes: [
      { id: 'local-special', name: 'Local Special', tags: ['Popular'], description: 'Set your city to see curated dishes.' },
      { id: 'street-favourite', name: 'Street Favourite', tags: ['Trending'], description: 'Discover what people order most.' }
    ],
    restaurants: [
      { id: 'r-1', name: 'Top Rated Restaurant', area: 'Near you', popularDishes: ['local-special'] },
      { id: 'r-2', name: 'Crowd Favourite', area: 'City centre', popularDishes: ['street-favourite'] }
    ]
  };
};
